<template>
  <div class="animated fadeIn">
    <b-row class="top-buffer">
      <b-col md="12">
        <b-button type="button" variant="primary" @click="createClientModal = true"><i class="fa fa-plus"></i>&nbsp;Create client</b-button>
      </b-col>
    </b-row>
    <CreateClient v-if="createClientModal" @hidden="createClientModal = false" @created="createdClient"></CreateClient>
    <EditClient v-if="editClientModal" @hidden="editClientModal = false" @edited="editedClient" @error="editClientError" :clientID="editClient.id"></EditClient>
    <br>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Client Search</strong>
          </div>
          <b-form @submit.prevent="searchClients()">
            <b-form-group
              label="Name"
              label-for="clientName"
              :label-cols="1"
              :horizontal="true">
              <b-form-input id="clientName" type="text" autocomplete="name" v-model="client.name" @keypress.native="error = null"></b-form-input>
            </b-form-group>
            <b-form-group
              label="Email"
              label-for="clientEmail"
              :label-cols="1"
              :horizontal="true">
              <b-form-input id="clientEmail" type="email" autocomplete="email" v-model="client.email" @keypress.native="error = null"></b-form-input>
            </b-form-group>
            <b-form-group
              label="Phone"
              label-for="clientPhone"
              :label-cols="1"
              :horizontal="true">
              <b-form-input id="clientPhone" type="text" autocomplete="name" v-model="client.phone" @keypress.native="error = null"></b-form-input>
            </b-form-group>
            <div slot="footer">
              <transition name="fade">
                <b-alert show variant="danger" style="width: 100%;" v-if="error">{{error.message}}</b-alert>
              </transition>
              <b-button type="submit" size="sm" variant="primary" class="btn btn-primary ladda-button" id="search-button" data-style="expand-right"><i class="fa fa-search"></i> Search</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    
    <transition name="fade">
      <b-row v-if="$store.state.clientsSearched.length > 0">
        <b-col md="12">
          <b-card>
            <div slot="header">
              <i class="icon-people"></i>
              <strong> Clients</strong>
            </div>
            <v-client-table name="searchedClientsDatatable" :columns="columns" :data="$store.state.clientsSearched" :options="options" :theme="theme" id="dataTable" v-if="$store.state.clientsSearched.length > 0" @row-click="onRowClick">
            </v-client-table>
          </b-card>
        </b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>

import api from '../../api'
import config from '../../config'
import store from '../../store'
import router from '../../router'
// import cTable from './ClientTable.vue'
import Vue from 'vue'
import {ClientTable, Event} from 'vue-tables-2'
import * as Ladda from 'ladda'
import CreateClient from './CreateClient.vue'
import EditClient from './EditClient.vue'

import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

miniToastr.setIcon('success', 'i', {'class': 'fa fa-check-circle-o'})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
//  VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)

Vue.use(ClientTable)

export default {
  name: 'clientsSearch',
  components: {
    ClientTable,
    Event,
    CreateClient,
    EditClient
  },
  data () {
    return {
      client: { // form input fields
        name: null,
        email: null,
        phone: null
      },
      searchButton: null,
      error: null,
      createClientModal: false,
      editClientModal: false,
      editClient: {
        id: null,
        name: null
      },
      columns: ['name', 'email', 'phone', 'isAdmin'],
      options: {
        headings: {
          name: 'Name',
          email: 'Email',
          phone: 'Phone',
          isAdmin: 'Admin'
        },
        templates: {
          isAdmin: function (h, row, index) {
            if (row.isAdmin) return <i class="fa fa-check"></i>
            return ''
          }
        },
        sortable: ['name', 'email', 'phone', 'isAdmin'],
        filterable: ['name', 'email', 'phone'],
        sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
        pagination: {
          chunk: 5,
          edge: true,
          nav: 'fixed'
        }
      },
      useVuex: true,
      theme: 'bootstrap4',
      template: 'default'
    }
  },
  created: function() {
    if (store.state.clientsSearchFields) this.client = store.state.clientsSearchFields
  },
  mounted: function() {
    this.searchButton = Ladda.create(document.querySelector( '#search-button' ))
  },
  methods: {
    searchClients: function() {
      this.error = null
      this.searchButton.start()
      api.request('get', config.serverURI + 'clients', null, {
          name: this.client.name,
          email: this.client.email,
          phone: this.client.phone
        })
        .then(response => {
          store.commit('CLIENTS_SEARCH', response.data, this.client)
          this.searchButton.stop()
          if (response.data.length === 0) {
            this.error = {
              message: 'No clients match the search parameters!'
            }
          }
        })
        .catch(error => {
          store.commit('CLIENTS_SEARCH', [], this.client)
          this.searchButton.stop()
          if (error.response ) {
            this.error = {
              message: error.response.data
            }
          } else {
            this.error = {
              message: 'Server error!'
            }
          }
        })
    },
    onRowClick: function(event) {
      this.editClient.id = event.row.id
      this.editClient.name = event.row.name
      this.editClientModal = true
      // console.log(event.row)
      // router.push('client/' + event.row.id)
    },
    createdClient: function(client) {
      miniToastr.success('Client '+ client.name + ' was created successfully', 'Client created!')
    },
    editedClient: function(client) {
      miniToastr.success('Client '+ client.name + ' was edited successfully', 'Client edited!')
      this.searchClients() //force client list update
    },
    editClientError: function(event) {
      miniToastr.warn('Unable to edit client ' + this.editClient.name)
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

  .fade-enter-active {
    transition: all .8s ease;
  }
  .fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    /* transform: translateX(10px); */
    opacity: 0;
  }
</style>

<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }

    .VueTables__child-row-toggler--closed::before {
      content: "+";
    }

    .VueTables__child-row-toggler--open::before {
      content: "-";
    }
  }

</style>

